<template lang="pug">
div
  .flex-between
    form(
      v-on:submit.prevent="fetchLocations({})"
      style="width: 100%;"
    )
      .row
        .col-md-7
          .input-group
            input.form-control(type="search" placeholder="Search" v-model="locationsStore.searchQuery")
            span.input-group-btn
              button.btn.btn-default(type="submit")
                i.fa.fa-search

        .col-md-1.text-center.or-text
          i or
        .col-md-4.text-right
          button.btn.btn-primary(
            type="button"
            @click="showForm"
          )
            | Create New Location

  br

  LoaderOverlay(:loading="loading")
    ul.list-group.locations
      li.list-group-item.location(
        v-for="location in locationsStore.searchResults"
      )
        .row
          .col-md-1
            i.fa.fa-map-marker.fa-2x
          .col-sm-10
            strong {{ location.title }}
            .text-muted {{ location.street1 }}, {{ location.city }}, {{ location.state }} {{ location.zip }}
          .col-sm-1
            span.pull-right
              button.btn.btn-success.add-location(
                type="button"
                :disabled="disabledLocationIds.includes(location.id)"
                @click="add(location.id)"
              )
                i.fa.fa-plus
                |
                | Add

      li.list-group-item(
        v-if="locationsStore.noResults"
      )
        .alert.alert-info No locations found

    .row
      .col-md-12.text-center
        Pagination(
          :current="locationsStore.page.current"
          :per="perPage"
          :total-records="locationsStore.page.total_records"
          :max-pages="5"
          @change="changePage"
        )
</template>

<script>
  import { mapStores } from 'pinia'
  import { useLocationsStore } from '../../../../../stores/locations'

  import LoaderOverlay from '../../../../../components/shared/loader_overlay.vue'
  import Pagination from '../../../../../components/shared/pagination.vue'

  export default {
    components: {
      LoaderOverlay,
      Pagination
    },

    props: {
      addAction: {
        type: Function,
        required: true
      },

      disabledLocationIds: {
        type: Array,
        default() { return [] }
      },

      perPage: {
        type: Number,
        default() { return 6 }
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useLocationsStore),
    },

    mounted() {
      this.fetchLocations({})
    },

    methods: {
      async add(locationId) {
        this.addAction({ locationId })
      },

      async fetchLocations({ page }) {
        this.loading = true

        this.locationsStore.search({
          page: page || 1
        }).then(() => {
          this.loading = false
        })
      },

      async showForm() {
        this.locationsStore.newForm = true
      },

      async changePage(page) {
        this.fetchLocations({ page })
      },

      async reset() {
        this.locationsStore.$reset()
        this.loading = false
      },
    }
  }
</script>

<style lang="scss">
  .or-text {
    margin-top: 5px;
  }
</style>
